export const Select = {
  baseStyle: {
    field: {
      color: 'mainGrey',
      background: 'white',
    },
  },
}
